'use client';

import { createContext, useContext } from 'react';

type ScrollbarInstance = null;

const SmoothScrollContext = createContext<ScrollbarInstance>(null);

export function useSmoothScroll() {
  return useContext(SmoothScrollContext);
}

interface SmoothScrollProviderProps {
  children: React.ReactNode;
}

export function SmoothScrollProvider({ children }: SmoothScrollProviderProps) {
  // Simplified version - using native scroll for now
  // Can add smooth-scrollbar back once basic functionality works
  return (
    <SmoothScrollContext.Provider value={null}>
      <div id="content-scroll">
        {children}
      </div>
    </SmoothScrollContext.Provider>
  );
}
